<template>
    <el-dialog :title="$t('preview')"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               @close="dialogClose"
               center
               width="720px"
               top="5vh">
        <div class="content">
            <div class="picture" style="width: 600px;">
                <img :src="parentImage" width="600" alt="">
                <div class="cover" :style="getCoverStyle(item)" v-for="item in list" :key="item.id"></div>
            </div>
        </div>
        <div slot="footer"
             class="dialog-footer">
            <el-button size="mini" @click="dialogVisible = false">{{ $t('close') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {
    queryAdvertCropperList,
} from "@/api/modules/api";

export default {
    name: 'Preview',
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
        parentId: {
            type: String,
            default: ''
        },
        parentImage: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            dialogVisible: false,
            list: []
        }
    },
    created () { },
    mounted () { },
    components: {},
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            this.list = []
            this.getDetails()
        },
    
        // 获取切图详情
        getDetails() {
            const params = {
                showcaseItemId: this.parentId
            }
            queryAdvertCropperList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.list = res.data || []
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
    
        // 获取遮盖层样式
        getCoverStyle (data) {
            return `width: ${data.lengthProportion * 100}%; height: ${data.highProportion * 100}%; left: ${data.lengthCoordinate * 100}%; top: ${data.highCoordinate * 100}%;`
        },
    
        // 关闭弹窗
        dialogClose () {
            this.$emit('parent-close')
        }
    },
}
</script>

<style scoped lang="scss">
.content{
    width: 100%;
    display: flex;
    justify-content: center;
    .picture{
        position: relative;
        .cover{
            position: absolute;
            background-color: rgba(0, 0, 0, .6);
        }
    }
}
</style>
